// IE 2026 09 15 / ODOO-… (замечание Игоря): движок «муравьёв» для карты со связями и графа — частицы по маршрутам
// (fl.pointAt(t, ant) → {x, y} в пикселях холста), выпуск за месяц ∝ объёму месяца (потоки без месяцев — по весу, на каждом круге часов),
// хвост из 4 точек, шаг по времени, отрисовка на canvas. Логика та же, что в AttrAntFlow (канвас поставщик → hub → страна).
// IE 2026 09 15 (заказ Игоря: цепочка на карте): поток может быть «разбеганием» — продажи узла муравьями во все стороны в рамках
// территории: fl.init(ant, k, n) задаёт муравью направление и длину пути, fl.fade — муравей тает к концу пути.
export const ANT_PALETTE = ['#4f7bd9', '#e08a2a', '#3aa76d', '#c94f7c', '#7a5cc9', '#2a9fbf', '#b8a12a', '#d9534f', '#5b7d8f', '#8f6b3a']

// цвет для суффикса прозрачности: #rrggbb; всё остальное — из палитры по индексу
export function antHex(color, i = 0) {
    const s = String(color || '')
    if (/^#[0-9a-f]{6}$/i.test(s)) return s
    const m = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(s)
    if (m) return '#' + [m[1], m[2], m[3]].map(x => (+x).toString(16).padStart(2, '0')).join('')
    return ANT_PALETTE[i % ANT_PALETTE.length]
}

export const quadAt = (p1, c, p2, t) => ({
    x: (1 - t) * (1 - t) * p1.x + 2 * (1 - t) * t * c.x + t * t * p2.x,
    y: (1 - t) * (1 - t) * p1.y + 2 * (1 - t) * t * c.y + t * t * p2.y,
})

const TAIL = [1, 0.8, 0.53, 0.27]   // прозрачность головы и трёх точек хвоста
const hexA = (a) => Math.round(Math.max(0, Math.min(1, a)) * 255).toString(16).padStart(2, '0')

export class AntRunner {
    constructor(opts = {}) {
        this.flows = []; this.ants = []; this.unit = 1; this.spawned = {}; this.lap = -1
        this.travelMs = opts.travelMs || 1800; this.maxAnts = opts.maxAnts || 1500
        this.perFlowMax = opts.perFlowMax || 60; this.antsPerMax = opts.antsPerMax || 40
    }
    // flows: [{ key, color: '#rrggbb', size?, months: {m: q} | null, weight?: number, pointAt: (t, ant) => {x, y} | null,
    //           init?: (ant, k, n) => void, fade?: boolean, kind?: 'link' | 'scatter' }]
    setFlows(flows) {
        this.flows = flows || []
        let maxM = 0
        for (const fl of this.flows) {
            if (fl.months) { for (const q of Object.values(fl.months)) if (q > maxM) maxM = q }
            else if ((fl.weight || 0) > maxM) maxM = fl.weight || 0
        }
        this.unit = maxM > 0 ? maxM / this.antsPerMax : 1
    }
    reset() { this.ants = []; this.spawned = {}; this.lap = -1; this.freezeLap = null }   // IE 2026 09 15: сброс (новые потоки) → в паузе на одном месяце партия-снимок выпускается заново
    // выпуск за месяц (или «all» для потоков без месяцев); повтор за тот же месяц того же круга не выпускает
    spawn(month, lap) {
        if (this.lap !== lap) { this.lap = lap; this.spawned = {} }
        const tag = String(month || 'all')
        if (this.spawned[tag]) return 0
        this.spawned[tag] = true
        let n0 = 0
        for (const fl of this.flows) {
            const q = fl.months ? (fl.months[month] || 0) : (fl.weight || 0)
            if (!(q > 0)) continue
            const n = Math.max(1, Math.min(this.perFlowMax, Math.round(q / this.unit)))
            for (let k = 0; k < n; k++) {
                const a = { fl, t: -k / n * 0.6, color: fl.color || ANT_PALETTE[0], size: fl.size || (1.6 + Math.min(2.4, Math.log10(1 + q) / 3)) }
                if (fl.init) fl.init(a, k, n)
                this.ants.push(a)
            }
            n0 += n
        }
        return n0
    }
    step(dt, speed) {
        const s = dt * (speed || 1) / this.travelMs
        for (const a of this.ants) a.t += s * (a.speed || 1)
        if (this.ants.length > this.maxAnts) this.ants.splice(0, this.ants.length - this.maxAnts)
        this.ants = this.ants.filter(a => a.t < 1.02)
    }
    // IE 2026 09 15 (замечание Игоря, вечер): пауза при ОДНОМ месяце шкалы — муравьи стартуют от узлов и замирают, когда головной
    // дошёл до freezeAt пути (снимок «начала движения» без цикла); true — ещё движемся
    stepTo(dt, speed, freezeAt = 0.5) {
        let lead = -Infinity
        for (const a of this.ants) if (a.t > lead) lead = a.t
        if (!(lead < freezeAt)) return false
        const s = Math.min(dt * (speed || 1) / this.travelMs, freezeAt - lead)
        for (const a of this.ants) a.t = Math.min(freezeAt, a.t + s * (a.speed || 1))
        return true
    }
    // снимок для паузы: свежая партия месяца (прежние муравьи убраны) — зовётся при входе в паузу и при смене месяца / круга
    freezeBatch(month, lap) {
        this.ants = []; this.spawned = {}; this.lap = lap; this.freezeLap = lap
        return this.spawn(month, lap)
    }
    draw(ctx) {
        for (const a of this.ants) {
            if (a.t < 0) continue
            const fade = a.fl.fade ? Math.max(0, 1 - Math.max(0, a.t - 0.35) / 0.65) : 1   // тает на последних двух третях пути
            if (fade <= 0.02) continue
            for (let k = 3; k >= 0; k--) {
                const t = a.t - k * 0.012; if (t < 0) continue
                const p = a.fl.pointAt(Math.min(1, t), a); if (!p) continue
                ctx.beginPath(); ctx.fillStyle = a.color + hexA(TAIL[k] * fade)
                ctx.arc(p.x, p.y, a.size * (1 - k * 0.15), 0, Math.PI * 2); ctx.fill()
            }
        }
    }
    // объём месяца по потокам (для строки статистики плеера); kind — только потоки этого вида
    volume(month, kind) {
        let v = 0
        for (const fl of this.flows) { if (kind && (fl.kind || 'link') !== kind) continue; v += fl.months ? (fl.months[month] || 0) : (fl.weight || 0) }
        return v
    }
}
